export var PRODUCT_TILE = 'productTile';
export var PRODUCT_TILE_CURRENT_PRICE = 'productTileCurrentPrice';
export var PRODUCT_TILE_OLD_PRICE = 'productTileOldPrice';
export var PRODUCT_TILE_BUNDLES_IMAGES = 'productTileBundlesImages';
//# sourceMappingURL=productTile.js.map